var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListSubheader = void 0;
var ListSubheader_1 = __importDefault(require("./ListSubheader"));
exports.ListSubheader = ListSubheader_1.default;
exports.default = ListSubheader_1.default;
//# sourceMappingURL=index.js.map